export default "__VITE_ASSET__BmJlOvfq__"